import React from 'react';

function World() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      data-name="Group 2069"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 997"></path>
      <g
        className="iconFillNone"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        data-name="Icon feather-globe"
        transform="translate(1.999 2)"
      >
        <path
          d="M20 10A10 10 0 1110 0a10 10 0 0110 10z"
          data-name="Path 3131"
        ></path>
        <path d="M0 10.001h20" data-name="Path 3132"></path>
        <path
          d="M10 0a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"
          data-name="Path 3133"
        ></path>
      </g>
    </svg>
  );
}

export default World;
